/**
 * Slash commands for the message box: typing "/" lists them, and picking one fills in its message with the part to
 * complete, written in [brackets], selected so the user types over it.
 */
import type { SubagentSlug } from '@diggens/types';
import type { SlashCommand } from '@diggens/chat';
import { SET_UP_FUND_PROMPT } from '../../constants/prompts';

export { fillTemplate, matchSlash, type SlashCommand } from '@diggens/chat';

const QUARTER = /^Q[1-4] \d{4}$/;

/** The commands the Chief of Staff can carry out for this workspace; Research and Draft need those specialists recruited. */
export function slashCommands({ period, specialists }: { period: string | null; specialists: ReadonlySet<SubagentSlug> }): SlashCommand[] {
  const commands: SlashCommand[] = [
    { name: 'status', description: 'Who has reported for a period', template: `Who has reported for ${period ?? '[period]'}?` },
    { name: 'fund', description: 'Set up a new fund', template: SET_UP_FUND_PROMPT },
    { name: 'import', description: 'Import portfolio companies', template: 'I want to import portfolio companies' },
    { name: 'metrics', description: 'Define the metrics a fund collects', template: 'I need to define metrics for a fund' },
  ];
  // The anomaly check compares quarters
  if (period && QUARTER.test(period)) {
    commands.push({ name: 'anomalies', description: 'Check a quarter’s numbers for unusual changes', template: `Check the ${period} submissions for anomalies against the prior quarter.` });
  }
  if (specialists.has('research')) {
    commands.push({ name: 'research', description: 'Research a firm and save it to the CRM', template: 'Research [firm or domain] on the web and save the findings to the CRM.' });
  }
  if (specialists.has('bdr')) {
    commands.push({ name: 'draft', description: 'Draft outreach to a contact', template: 'Draft a short intro email to [name, role and firm].' });
  }
  return commands;
}
